import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { workspaceApi } from "pages/app/workspace/services";

export const useSchoolPlayerIdentity = (schoolId: string, playerId: string) => {
  const schoolPlayerQuery = useQuery({
    queryKey: ["school-player-profile-school-player", schoolId, playerId],
    queryFn: () => workspaceApi.schoolPlayers.get(schoolId, playerId),
    enabled: Boolean(schoolId) && Boolean(playerId),
  });
  const athleteQuery = useQuery({
    queryKey: ["school-player-profile-athlete", playerId],
    queryFn: () => workspaceApi.athletes.get(playerId),
    enabled: Boolean(playerId),
  });

  const schoolPlayer = schoolPlayerQuery.data;
  const athlete = athleteQuery.data;

  const linkedTeams = useMemo(
    () => schoolPlayer?.school_teams || athlete?.school_summary?.school_team_summaries || [],
    [athlete?.school_summary?.school_team_summaries, schoolPlayer?.school_teams],
  );

  const linkedSports = useMemo(
    () =>
      schoolPlayer?.school_sports ||
      (athlete?.school_summary?.school_sport_names || []).map((name: string, index: number) => ({
        id: `sport-${index}`,
        name,
      })),
    [athlete?.school_summary?.school_sport_names, schoolPlayer?.school_sports],
  );

  const profileTitle = schoolPlayer?.full_name || athlete?.full_name || "School player";
  const hasProfile = Boolean(schoolPlayer || athlete);

  return {
    athlete,
    athleteLoading: athleteQuery.isLoading,
    athleteQuery,
    hasProfile,
    isLoading: schoolPlayerQuery.isLoading || athleteQuery.isLoading,
    linkedSports,
    linkedTeams,
    profileTitle,
    schoolPlayer,
    schoolPlayerQuery,
  };
};
